import React, { FC, useState } from 'react';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from '../../base/local-modal';
import logoutIcon from 'assets/icons/logout-icon.svg';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { handleApiError } from 'utils/functions';

interface DeletePostModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: string;
  title: string;
  handleDelete: () => void;
}

interface DeletePostModalFooterProps {
  onCancel: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const DeletePostModalFooter: FC<DeletePostModalFooterProps> = ({
  onCancel,
  onConfirm,
  loading
}) => (
  <div className='flex gap-2'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      onClick={onConfirm}
      loading={loading}>
      Confirm
    </Button>
  </div>
);

const DeletePostModal: FC<DeletePostModalProps> = ({
  isOpen,
  onClose,
  id,
  title,
  handleDelete
}) => {
  const [loading, setLoading] = useState(false);

  const confirmDelete = async () => {
    setLoading(true);
    try {
      const res = await apiService.delete(`marketing/post/${id}`);
      toast(<ToastMessage type='success' message={res.data.message} />);
      handleDelete();
      onClose();
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalModal
      isOpen={isOpen}
      onRequestClose={onClose}
      title='Delete Post'
      contentClassName='!max-w-[450px]'
      footer={
        <DeletePostModalFooter onCancel={onClose} onConfirm={confirmDelete} loading={loading} />
      }>
      <div className='flex flex-col justify-center items-center'>
        <img src={logoutIcon} className='mx-auto mb-5 mt-4' />
        <p className='text-[#2E3031] text-center'>
          Are you sure you want to delete<span className='font-semibold capitalize'> {title}</span>?
        </p>
      </div>
    </LocalModal>
  );
};

export default DeletePostModal;
